// Libs
import React from 'react';
import { useComponentsPool } from '../../../ComponentsPool';

const { Component } = useComponentsPool();

export default () => <></>;
